import type { DB, ObjectID } from '@/types/common';
import type { INotificationUserAgency } from '@/types/notification';
import type { IPerson } from '@/types/person';
import type { UserConfiguration } from '@/types/view';
import type { UserStatus } from '@/types/worker';

export enum UserRole {
	ADMIN = 'admin',
	ADMIN_SUPPORT = 'admin_support',
	SUPPORT = 'support',
	COLLABORATOR = 'collaborator',
	INTERIM = 'interim',
	MANAGER = 'manager',
	COMPANY = 'company',
	SUPERVISOR = 'supervisor',
	CANDIDATE = 'candidate',
}

export enum Feature {
	SALESFORCE = 'salesforce',
	EVOLIA_ORDERS = 'evolia-orders',
	PAYMENT_REQUEST = 'payment-request',
	EMAIL_ACTIVE_PROPOSAL = 'email-active-proposal',
}

export enum Brand {
	interaction = 'interaction',
}

export interface IUser extends IPerson {
	roles?: UserRole[];
	username?: string;
	password?: string;
	email?: string;
	picture?: string;
	jobId?: string;
	phone?: string;
	agencyId?: ObjectID;
	companyId?: ObjectID;
	businessSectors?: string[];
	configuration?: UserConfiguration;
	status?: UserStatus;
	firstConnectionToken?: string;
	features?: string[];
	position?: string;
	notifications?: INotificationUserAgency;
	agenciesPopulated?: {
		id: string;
		name: string;
		publicName: string;
		evolia: string;
	}[];
}

export interface IUserDB extends IUser, Partial<DB> {}
